import React, { useEffect, useMemo, useState } from 'react'
import VideoSummaryUi from './VideoSummaryUi'
import { getDashboardVideoSummaryApi } from '../../apis/dashboard.api';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import { callApiAction } from '../../store/actions/commonAction';
import moment from 'moment';
import fileDownload from 'js-file-download';

const VideoSummaryController = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [list, setlist] = useState()
    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: "",
        sort: "donation_date",
        sort: "eventName",
        sortDirection: 1,
    });
    const [exportLoading, setexportLoading] = useState(false)

    const fetchList = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await getDashboardVideoSummaryApi({ ...filters }),
                (response) => {
                    setLoading(false);
                    setlist(response);
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    }

    const fetchCsvList = () => {
        setexportLoading(true);
        dispatch(
            callApiAction(
                async () => await getDashboardVideoSummaryApi({ ...filters, isCsv: true }),
                (response) => {
                    setexportLoading(false);
                    fileDownload(response, "VideoSummary.csv")
                },
                (err) => {
                    setexportLoading(false);
                },
                true
            )
        );
    }

    const onExportBtnClick = () => {
        fetchCsvList()
    }

    const columns = useMemo(
        () => [
            {
                id: 1,
                fieldName: "eventName",
                label: "Event Name",
                align: "left",
                sort: true,
                renderValue: (params, setParams) => params?.eventName,
            },
            {
                id: 2,
                fieldName: "totalBeneficiaries",
                label: "Total Beneficiaries",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.totalBeneficiaries,
            },
            // {
            //     id: 3,
            //     fieldName: "donation_date",
            //     label: "Donation Date",
            //     align: "left",
            //     sort: false,
            //     renderValue: (params, setParams) => (
            //         <Typography textTransform="capitalize">{moment(params?.donation_date).format("DD/MM/YYYY")}</Typography>
            //     ),
            // },
            {
                id: 4,
                fieldName: "total",
                label: "Total Videos",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.total,
            },
            {
                id: 5,
                fieldName: "fivestar",
                label: "5 Star",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.fivestar,
            },
            {
                id: 7,
                fieldName: "fourStar",
                label: "4 Star",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.fourStar,
            },
            {
                id: 8,
                fieldName: "thirdStar",
                label: "3 Star",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.thirdStar,
            },
            {
                id: 9,
                fieldName: "secondStar",
                label: "2 Star",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => params?.secondStar,
            },
            {
                id: 10,
                fieldName: "firstStar",
                label: "1 Star",
                align: "left",
                sort: false,
                renderValue: (params, setParams) =>params?.firstStar,
            },
            {
                id: 8,
                fieldName: "average",
                label: "Average",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => Number(params?.average).toFixed(2),
            },
        ],
        []
    );

    useEffect(() => {
        fetchList();
    }, [filters])
    return (
        <VideoSummaryUi
            setlist={setlist}
            list={list}
            filters={filters}
            setFilters={setFilters}
            loading={loading}
            columns={columns}
            onExportBtnClick={onExportBtnClick}
            setexportLoading={setexportLoading}
            exportLoading={exportLoading}
        />
    )
}

export default VideoSummaryController